class FAQSeeMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.faq__see-more');
    this.sectionId = this.button?.dataset.sectionId;
    this.section = document.getElementById(`faq-${this.sectionId}`);
    this.items = this.section?.querySelector('.faq__items');
    this.hiddenItems = this.section?.querySelectorAll('.faq__item--hidden');
    this.seeMoreText = this.querySelector('.faq__see-more-text');
    this.seeLessText = this.querySelector('.faq__see-less-text');
    this.isExpanded = false;
    
    if (this.button) {
      this.button.addEventListener('click', this.toggleItems.bind(this));
    }
  }
  
  toggleItems() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.showAllItems();
    } else {
      this.hideExtraItems();
    }
  }
  
  showAllItems() {
    this.hiddenItems.forEach(item => {
      item.classList.remove('faq__item--hidden');
      item.classList.add('faq__item--visible');
    });
    
    this.seeMoreText.style.display = 'none';
    this.seeLessText.style.display = 'inline';
    this.button.setAttribute('aria-expanded', 'true');
  }
  
  hideExtraItems() {
    this.hiddenItems.forEach(item => {
      item.classList.remove('faq__item--visible');
      item.classList.add('faq__item--hidden');
    });
    
    this.seeMoreText.style.display = 'inline';
    this.seeLessText.style.display = 'none';
    this.button.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('faq-see-more', FAQSeeMore);